import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme, { Theme } from '@themes/theme';

/**
 * Task list row placeholder: checkbox + name + due-date pill + assignee
 * avatar. Mirrors `ComposedTaskRow` in `stories/atoms/Skeleton.stories.tsx`.
 * Used for both My Tasks and project Tasks tab rows.
 */
export const TaskRowSkeleton: React.FC<{
  testID?: string;
  paddingHorizontal?: keyof Theme['spacing'];
}> = ({ testID = 'task-row-skeleton', paddingHorizontal = 's' }) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='s'
      paddingHorizontal={paddingHorizontal}
      borderBottomWidth={1}
      borderBottomColor='grey02'>
      <Skeleton
        variant='circle'
        width={20}
        height={20}
        style={{ marginRight: theme.spacing.s }}
      />
      <Box flex={1} marginRight='s'>
        <Skeleton variant='text' width='55%' />
      </Box>
      <Skeleton
        variant='rect'
        width={90}
        height={28}
        borderRadius='xs'
        style={{ marginRight: theme.spacing.s }}
      />
      <Skeleton variant='circle' width={28} height={28} />
    </Box>
  );
};
